import axios from 'axios';
import Vue from 'vue'

const state = { status: '', teams: [], individual: [] };

const getters = {
  getTeams: state => state.teams,
  getIndividual: state => state.individual,

};

const actions = {
  requestIndividual ({ commit, dispatch }) {
   return new Promise((resolve, reject) => {
    axios({ url:  `${process.env.VUE_APP_ROOT_API}/leaderboard/personal/` })
      .then(resp => {
        commit('setIndividual', resp.data);
        resolve(resp);
      })
      .catch(err => {
        reject(err);
      })
    })
  },
  requestTeams({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
    axios({ url: `${process.env.VUE_APP_ROOT_API}/leaderboard/teams/`}) 
      .then(resp => {
        commit('setTeams', resp.data)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
};

const mutations = {
  setTeams(state, teams) {
    state.status = 'success';
    state.teams =  teams;
  },
  setIndividual(state, individual) {
    state.status = 'success';
    state.individual =  individual;
  },
};
const namespaced = true;
export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
